import { FormGroup } from '@mui/material';
import * as coreApi from "api/Core";
import BoxDrawer from 'components/BoxDrawer';
import IconSubordinates from 'components/Icons/IconSubordinates';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import TextFieldCounter from 'components/TextFieldCounter';
import { MemberSuggestionDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import MemberAutoComplete, { MemberAutoCompleteSearchParams } from 'views/Member/Components/MemberAutoComplete';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    members: Array<MemberSuggestionDto>;
    comment: string;
    canSave: boolean;
}

interface IProps {
    topicId: string;
    onClose: (result: { members: MemberSuggestionDto[], comment: string; }) => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TopicRequestKnowlegeTestDrawer extends React.PureComponent<Props, IState> {

    private apiGetSuggestions = coreApi.getTopicSubordinateMemberSuggestions();

    ///
    constructor(props: Props) {
        super(props);
        this.state = {
            comment: "",
            members: null,
            canSave: false
        };
    }

    ///
    public render() {
        const { onClose } = this.props;

        const label = (
            <>
                <IconSubordinates title={this.props.t("Views.Timeline.Dialogs.TopicRequestKnowlegeTestDrawer.SubordinateTitle")} />
                {this.props.t("Views.Timeline.Dialogs.TopicRequestKnowlegeTestDrawer.SubordinateText")}
            </>
        );

        return (
            <BoxDrawer
                open
                title={this.props.t("Views.Timeline.Dialogs.TopicRequestKnowlegeTestDrawer.BoxTitle")}
                subtitle={this.props.t("Views.Timeline.Dialogs.TopicRequestKnowlegeTestDrawer.Subtitle")}
                onClose={() => { onClose(null); }}
            >
                <MuiPaper dense elevation={0}>

                    <FormGroup>
                        <MemberAutoComplete
                            autoFocus
                            overModal
                            label={label}
                            placeholder={this.props.t("Views.Timeline.Dialogs.TopicRequestKnowlegeTestDrawer.MemberPlaceholder")}
                            error={this.state.members != null && this.state.members.length == 0}
                            selectedItems={this.state.members}
                            margin="normal"
                            onCustomGetMembers={
                                (p: MemberAutoCompleteSearchParams): Promise<MemberSuggestionDto[]> => {
                                    return this.apiGetSuggestions.execute({
                                        topicId: this.props.topicId,
                                        searchText: p.searchText,
                                        offset: p.offset,
                                        take: p.take
                                    });
                                }
                            }
                            onChange={
                                (members) => {
                                    this.setState({
                                        members,
                                        canSave: members.length > 0
                                    });
                                }
                            }
                        />
                    </FormGroup>

                    <FormGroup>
                        <TextFieldCounter
                            fullWidth
                            multiline
                            placeholder={this.props.t("Views.Timeline.Dialogs.TopicRequestKnowlegeTestDrawer.CommentPlaceholder")}
                            maxLength={1500}
                            margin="normal"
                            value={this.state.comment}
                            onChange={
                                (comment) => {
                                    this.setState({ comment });
                                }
                            }
                        />
                    </FormGroup>

                    <MuiRegularButton
                        fullWidth
                        disabled={!this.state.canSave}
                        color="secondary"
                        onClick={
                            () => {
                                onClose({ members: this.state.members, comment: this.state.comment });
                            }}
                    >
                        <span>{this.props.t("Common.Buttons.CreateText")}</span>
                    </MuiRegularButton>

                </MuiPaper>

            </BoxDrawer>
        );
    }
}

export default withTranslation()(TopicRequestKnowlegeTestDrawer);